import { render, staticRenderFns } from "./TgContactCard.vue?vue&type=template&id=aa4e7828&"
import script from "./TgContactCard.vue?vue&type=script&lang=js&"
export * from "./TgContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports